import type { StyledProps } from "styled-components";
import styled from "styled-components";
import { remCalculator, setInlineStyles } from "util/style-utils";

export const Heading1 = styled.h1`
    font-size: ${remCalculator(20)};
    line-height: ${remCalculator(33.6)};
    font-weight: ${(props) => props.theme.fontWeightRegular};
`;

export const Heading2 = styled.h2`
    font-size: ${remCalculator(14)};
    line-height: ${remCalculator(33.6)};
    font-weight: ${(props) => props.theme.fontWeightSemiBold};
`;

export const Heading3 = styled.h3`
    font-size: ${remCalculator(14)};
    line-height: ${remCalculator(33.6)};
    font-weight: ${(props) => props.theme.fontWeightLight};
`;

export const Heading4 = styled.h4`
    font-size: ${remCalculator(12)};
    line-height: ${remCalculator(33.6)};
    text-transform: uppercase;
    font-weight: ${(props) => props.theme.fontWeightRegular};
`;

export const Paragraph = styled.p`
    font-size: ${remCalculator(12)};
    font-weight: ${(props) => props.theme.fontWeightRegular};
    line-height: ${remCalculator(18)};

    & strong {
        font-weight: ${(props) => props.theme.fontWeightBold};
    }
`;

export const Title = styled.p`
    white-space: pre;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Info = styled.small`
    font-size: ${remCalculator(11)};
    line-height: ${remCalculator(16)};
    vertical-align: middle;
`;

export const Small = Info;

export const ImportantInfo = styled(Info)`
    text-transform: uppercase;
`;
export const Label = ImportantInfo.withComponent(`label`);

export const LinkText = setInlineStyles(
    styled.a,
    ({ disabled, theme }: StyledProps<{ disabled?: boolean }>) => ({
        color: !disabled ? theme.colors.primary : `inherit`
    })
)`
	pointer-events: auto;
	background: none;
    border: none;
	text-decoration: underline;
	text-transform: uppercase;
	cursor: pointer;
	&[disabled] {
		&:hover {
			color: ${(props) => props.theme.colors.backgroundDarkGrey};
		}
		color: ${(props) => props.theme.colors.backgroundDarkGrey};
	}
`;

// for hiding text that we still want screen readers (or testing-library to pick up)
export const VisuallyHidden = styled.div`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`;
